const ENSelectUsers = {
	"Adicionar usuários por grupo": "Add users by group",
	"Adicionar usuários": "Add users",
	"Erro ao buscar usuários": "Error loading users",
	"Erro ao carregar grupos de usuários": "Error loading user groups"
};

export default ENSelectUsers;
